import { z } from 'zod';
import { BaseResponseSchema, FuzzySearchRequestSchema, FuzzySearchResponseSchema, MultiFieldSearchRequestSchema, MultiFieldSearchResponseSchema, SimpleSearchRequestSchema, SimpleSearchResponseSchema, UniversalSearchRequestSchema, UniversalSearchResponseSchema, } from '../../schemas.js';
const SearchHealthDataSchema = z.object({
    status: z.string(),
    responseTime: z.number(),
    timestamp: z.string(),
});
/** REST contract for `insight-api/src/routes/search.routes.ts`. */
export const searchContract = {
    simple: {
        method: 'POST',
        path: '/search/simple',
        body: SimpleSearchRequestSchema,
        response: SimpleSearchResponseSchema,
        responseStyle: 'parse-response',
    },
    fuzzy: {
        method: 'POST',
        path: '/search/fuzzy',
        body: FuzzySearchRequestSchema,
        response: FuzzySearchResponseSchema,
        responseStyle: 'parse-response',
    },
    multiField: {
        method: 'POST',
        path: '/search/multi-field',
        body: MultiFieldSearchRequestSchema,
        response: MultiFieldSearchResponseSchema,
        responseStyle: 'parse-response',
    },
    universal: {
        method: 'POST',
        path: '/search/universal',
        body: UniversalSearchRequestSchema,
        response: UniversalSearchResponseSchema,
        responseStyle: 'parse-response',
    },
    health: {
        method: 'GET',
        path: '/search/health',
        response: BaseResponseSchema.extend({ data: SearchHealthDataSchema }),
        responseStyle: 'unwrap-data',
    },
};
//# sourceMappingURL=search.contract.js.map